"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeXabcdeTemp85PatchLike = void 0;
const index_1 = require("../index");
const utils_1 = require("../utils");
const makeXabcdeTemp85PatchLike = (sectionNames = ['X', 'A', 'B', 'C', 'D', 'E']) => {
    return [
        /**
         * Intervention / Équipe
         * **/
        {
            '@type': 'grid',
            'key': 'eaa87a98-83a6-4784-854b-dffb7dc49f4f',
            columns: 1,
            children: [
                /**
                 * Intervention / Équipe
                 * **/
                {
                    '@type': 'card',
                    key: '4843d864-5253-44ae-8ac2-620a298dbd3c',
                    title: 'Intervention / Équipe',
                    gridColumn: '1/2',
                    className: 'cardCntnr',
                    children: [
                        {
                            '@type': 'grid',
                            key: '104374a0-ac4b-4050-82fb-e19aec828593',
                            columns: 3,
                            children: [
                                ...index_1.template.ticketNumMotif,
                                ...index_1.template.equipeInfos,
                                ...index_1.template.vehiculesIntervention,
                                ...index_1.template.pisteSkiable,
                            ],
                        },
                    ],
                },
            ],
        },
        /**
         * Circonstances
         * **/
        {
            '@type': 'grid',
            'key': '916903b2-0521-44e9-a3d4-32d26acc69b1',
            columns: 5,
            children: [
                /**
                 * Circonstanciel
                 * **/
                {
                    '@type': 'card',
                    key: 'c2456c66-1b2f-42ee-a533-af0f20669e66',
                    title: 'Circonstances',
                    gridColumn: '1/3',
                    children: [
                        ...index_1.template.lieuIntervention,
                        ...index_1.template.accidentField,
                        ...index_1.template.maladieMalaiseField,
                        ...index_1.template.circonstances,
                    ],
                },
                /**
                 * Identité
                 * **/
                {
                    '@type': 'card',
                    key: '5516f091-9a5e-4f98-912b-c85ca7bf2232',
                    title: 'Identité',
                    gridColumn: '3/5',
                    children: [...index_1.template.identite],
                },
                /**
                 * Contacts
                 * **/
                {
                    '@type': 'card',
                    key: '59060cb6-4180-4b82-b4b1-78da2dee2e2a',
                    title: cUser => ((0, utils_1.hasPerm)(cUser, 'assessment:sdis64') ? 'Informations complémentaires' : 'Contacts'),
                    gridColumn: '5/6',
                    children: [...index_1.template.contact],
                },
            ],
        },
        /**
         * MHTA / PQRST
         * **/
        {
            '@type': 'grid',
            key: '8bf13c5d-1802-4fbf-b40c-0c8f36a928af',
            columns: 2,
            children: [
                /**
                 * MHTA
                 * **/
                {
                    '@type': 'card',
                    key: 'ccf612a0-b57e-4e77-91c4-29662724b96e',
                    title: 'MHTA',
                    gridColumn: '1/2',
                    children: [
                        ...index_1.template.mhta,
                        ...index_1.template.evenementSampler,
                        ...index_1.template.lunchSampler
                    ],
                },
                /**
                 * PQRST
                 * **/
                {
                    '@type': 'card',
                    key: '99beec31-11f8-4e13-8187-eb93bf26c690',
                    title: 'PQRST',
                    gridColumn: '2/3',
                    children: [
                        ...index_1.template.opqrst,
                        ...index_1.template.pqrst,
                        ...index_1.template.signeSampler,
                        ...index_1.template.observationsSampler,
                    ],
                },
            ],
        },
        /**
         * ACR / RCP
         * **/
        {
            '@type': 'grid',
            key: '6641c2b2-950d-4327-a580-56fbfe4701ad',
            columns: 2,
            children: [
                /**
                 * ACR
                 * **/
                {
                    '@type': 'card',
                    key: '6f652677-05e7-4f25-b2f1-3069a0fa6a96',
                    title: 'ACR',
                    gridColumn: '1/2',
                    children: [...index_1.template._85_acr],
                },
                /**
                 * RCP
                 * **/
                {
                    '@type': 'card',
                    key: 'e9daad01-8b24-4ba8-a317-ea13fdf87404',
                    title: 'RCP',
                    gridColumn: '2/3',
                    children: [...index_1.template.rcp],
                },
            ],
        },
        /**
         * Obstétrique / Secours routier
         * **/
        {
            '@type': 'grid',
            key: '8c0be844-5e7c-46d5-ac24-3a2b9f1dfe77',
            columns: 2,
            children: [
                /**
                 * Obstétrique
                 * **/
                {
                    '@type': 'card',
                    key: '8ad340a6-9cc0-4adf-8e77-101e7300d71a',
                    title: 'Obstétrique',
                    gridColumn: '1/2',
                    children: [...index_1.template.obstetriqueWithCategory],
                },
                /**
                 * Secours routier
                 * **/
                {
                    '@type': 'card',
                    key: 'f047d819-1691-414d-8bba-ab7f45339350',
                    title: 'Secours routier / Accidents',
                    gridColumn: '2/3',
                    children: [
                        ...index_1.template.secoursRoutier,
                        {
                            '@type': 'permission',
                            key: '045b0d54-78c3-43f1-a1e9-5d13689fbce5',
                            permission: ['!assessment:sdis64'],
                            children: [...index_1.template.atteinteCirconstancielAccidents],
                        },
                    ],
                }
            ],
        },
        /**
         * Gestes techniques
         * **/
        {
            '@type': 'grid',
            key: 'bd9994df-06d2-4402-ad67-178ecbdfbe4c',
            columns: 1,
            children: [
                /**
                 * Gestes techniques
                 * **/
                {
                    '@type': 'card',
                    key: 'f5ae4ce7-d02e-48c7-9486-c0d8e881a0b8',
                    title: 'Gestes techniques',
                    children: [...index_1.template._85_gesteTechnique],
                },
            ],
        },
        /**
         * XABCDE / Lésionnel
         * **/
        {
            /**
             * XABCDE
             * **/
            '@type': 'grid',
            key: '15e293e3-9920-4b5b-b929-09af03176e68',
            columns: 5,
            children: [
                /**
                 * XABCDE
                 * **/
                {
                    '@type': 'card',
                    key: 'b0919117-e2f7-4456-b1be-481f7485b05c',
                    gridColumn: '1 / 4',
                    className: 'cardCntnr',
                    children: [
                        /**
                         * X - Primary
                         * **/
                        {
                            '@type': 'grid',
                            key: '2ed9d17d-947a-4f54-b9a8-c376c70b819f',
                            columns: 3,
                            children: [
                                {
                                    '@type': 'card',
                                    key: 'bbdf133a-ad5e-4214-ae29-f27db4f948b9',
                                    gridColumn: '1 / 3',
                                    title: `${sectionNames[0]}`,
                                    children: [
                                        {
                                            '@type': 'grid',
                                            key: '7c2058f9-5ce0-426f-a298-780daa327573',
                                            columns: 2,
                                            children: [...index_1.template._85_xabcde],
                                        },
                                    ],
                                },
                                /**
                                 * X - Gestes
                                 * **/
                                {
                                    '@type': 'card',
                                    key: 'e02ffba6-9423-4ac6-9021-090036ce7f4f',
                                    gridColumn: '3 / 4',
                                    title: 'Gestes',
                                    children: [...index_1.template._85_xabcdeGeste],
                                }
                            ],
                        },
                        /**
                         * A - Primary & Secondary & Gestes
                         * **/
                        {
                            '@type': 'grid',
                            key: '7d4cf16c-6cbd-4c69-9c6d-b126d5291966',
                            columns: 3,
                            children: [
                                /**
                                 * A - Primary & Secondary
                                 * **/
                                {
                                    '@type': 'card',
                                    key: 'bbdf133a-ad5e-4214-ae29-f27db4f948b9',
                                    gridColumn: '1 / 3',
                                    title: `${sectionNames[1]}`,
                                    children: [
                                        {
                                            '@type': 'grid',
                                            key: '7c2058f9-5ce0-426f-a298-780daa327573',
                                            columns: 2,
                                            children: [...index_1.template.aAbcde],
                                        },
                                    ],
                                },
                                /**
                                 * A - Gestes
                                 * **/
                                {
                                    '@type': 'card',
                                    key: 'e02ffba6-9423-4ac6-9021-090036ce7f4f',
                                    gridColumn: '3 / 4',
                                    title: 'Gestes',
                                    children: [...index_1.template._85_aAbcdeGeste],
                                },
                            ],
                        },
                        /**
                         * B - Primary & Secondary & Gestes
                         * **/
                        {
                            '@type': 'grid',
                            key: '62d461bd-2550-43b4-a49f-9aca72f4f5d5',
                            columns: 3,
                            children: [
                                /**
                                 * B - Primary & Secondary
                                 * **/
                                {
                                    '@type': 'card',
                                    key: 'a370ded9-0959-4646-aeb8-89ee2206a615',
                                    gridColumn: '1 / 3',
                                    title: `${sectionNames[2]}`,
                                    children: [
                                        {
                                            '@type': 'grid',
                                            key: '7c2058f9-5ce0-426f-a298-780daa327573',
                                            columns: 2,
                                            children: [...index_1.template.bAbcde],
                                        },
                                    ],
                                },
                                /**
                                 * B - Gestes
                                 * **/
                                {
                                    '@type': 'card',
                                    key: '47af03ca-145f-4b4d-a0cd-dfbfbcc54d6a',
                                    gridColumn: '3 / 4',
                                    title: 'Gestes',
                                    children: [...index_1.template.bAbcdeGeste, ...index_1.template.gesteSmur, ...index_1.template.positionAttente],
                                },
                            ],
                        },
                        /**
                         * C
                         * **/
                        {
                            '@type': 'grid',
                            key: '767a0d34-5d5b-4c65-9271-1f3b02b920bb',
                            columns: 3,
                            children: [
                                /**
                                 * C - Primary & Secondary
                                 * **/
                                {
                                    '@type': 'card',
                                    key: '853869c5-5e0a-44d3-9c72-5f02716001d0',
                                    gridColumn: '1 / 3',
                                    title: `${sectionNames[3]}`,
                                    children: [
                                        {
                                            '@type': 'grid',
                                            key: '5fa0701a-82cb-4422-9cac-a6b7c027f7da',
                                            columns: 2,
                                            children: [...index_1.template._85_cAbcde],
                                        },
                                    ],
                                },
                                /**
                                 * C - Gestes
                                 * **/
                                {
                                    '@type': 'card',
                                    key: '69472023-f5a7-4edb-910d-f2aa86f6529f',
                                    gridColumn: '3 / 4',
                                    title: 'Gestes',
                                    children: [...index_1.template.positionAttente],
                                },
                            ],
                        },
                        /**
                         * D
                         * **/
                        {
                            '@type': 'grid',
                            key: '9b8ceeb6-0c16-45ec-85ce-e7aaa0b49834',
                            columns: 3,
                            children: [
                                /**
                                 * D - Primary & Secondary
                                 * **/
                                {
                                    '@type': 'card',
                                    key: 'f4c2aa87-6814-4181-a7c9-27d53b266de4',
                                    gridColumn: '1 / 3',
                                    title: `${sectionNames[4]}`,
                                    children: [
                                        {
                                            '@type': 'grid',
                                            key: '5fa0701a-82cb-4422-9cac-a6b7c027f7da',
                                            columns: 2,
                                            children: [...index_1.template._85_dAbcde],
                                        },
                                    ],
                                },
                                /**
                                 * D - Gestes
                                 * **/
                                {
                                    '@type': 'card',
                                    key: '46444252-25a9-4089-8a46-44502ab45e37',
                                    gridColumn: '3 / 4',
                                    title: 'Gestes',
                                    children: [...index_1.template.dAbcdeGeste],
                                },
                            ],
                        },
                        /**
                         * E
                         * **/
                        {
                            '@type': 'grid',
                            key: 'a9e00c90-40b5-454a-bd9d-06e9568c6c24',
                            columns: 3,
                            children: [
                                {
                                    '@type': 'card',
                                    key: '956b8036-8821-4138-b98a-acb776edbd2d',
                                    gridColumn: '1 / 3',
                                    title: `${sectionNames[5]}`,
                                    children: [
                                        {
                                            '@type': 'grid',
                                            key: '62ce8474-1775-4a82-9ed4-1366689a0b21',
                                            columns: 2,
                                            children: [...index_1.template._85_eAbcde],
                                        },
                                    ],
                                },
                                {
                                    '@type': 'card',
                                    key: '0adbd38f-0633-41fd-8317-8d0e6bbac89e',
                                    gridColumn: '3 / 4',
                                    title: 'Gestes',
                                    children: [
                                        ...index_1.template._85_eAbcdeGeste,
                                        ...index_1.template.positionAttente,
                                        ...index_1.template.pls
                                    ],
                                },
                            ],
                        },
                    ],
                },
                /**
                 * Lésionnel / FAST / Devenir
                 * **/
                {
                    '@type': 'card',
                    key: '8a5895ce-2b87-4cc0-a6cc-7ea1fd25ef04',
                    gridColumn: '4 / 6',
                    className: 'cardCntnr',
                    children: [
                        /**
                         * FAST
                         * **/
                        {
                            // FAST
                            '@type': 'card',
                            key: '6ee02cf0-200e-4dc3-ade5-a390f108840e',
                            title: 'FAST',
                            children: [
                                ...index_1.template.neurologiqueFast,
                                {
                                    '@type': 'permission',
                                    key: '5d16624f-ee47-47df-9415-ffb3372de79b',
                                    permission: ['web:bilan:extract-fast-out-of-neuro'],
                                    children: [
                                        ...index_1.template.nihssParalysieFacialeFast,
                                        ...index_1.template.nihssMotriciteMembreFast,
                                        ...index_1.template.neuroHeureAppDeficitFast,
                                        ...index_1.template.neuroTroubleParoleFast,
                                    ],
                                },
                            ],
                        },
                        /**
                         * Lésionnel
                         * **/
                        {
                            '@type': 'card',
                            key: 'e97b976d-7d26-4bd2-a199-4e578079d8fe',
                            title: 'Lésionnel',
                            children: [...index_1.template.lesionnel],
                        },
                        /**
                         * Devenir
                         * **/
                        {
                            '@type': 'card',
                            key: 'f13c870f-e648-4d94-9859-35e40ae51bc5',
                            title: 'Devenir',
                            children: [...index_1.template.devenir],
                        },
                    ],
                },
            ],
        },
        /**
         * Surveillances
         * **/
        {
            '@type': 'grid',
            key: '1fbd91e1-671d-46d2-9d11-12afd0d1f886',
            columns: 1,
            children: [
                /**
                 * Surveillances
                 * **/
                {
                    '@type': 'card',
                    key: '22fcd2af-d4ae-4e78-9826-e63aca89d3ca',
                    title: 'Surveillances',
                    children: [...index_1.template.surveillances],
                },
            ],
        },
    ];
};
exports.makeXabcdeTemp85PatchLike = makeXabcdeTemp85PatchLike;
